import CoverageList from "@/view/coverage/coverage_list.vue";
import CoverageNew from "@/view/coverage/coverage_new.vue";
import CoverageShow from "@/view/coverage/coverage_show.vue";
import CoverageEdit from "@/view/coverage/coverage_edit.vue";

const coverage = [
  { path: "/coverage",  component: CoverageList,  name: "coverage_list",  meta: { title: 'Cobertura', auth: false } },
  { path: "/coverage/new", component: CoverageNew, name: "coverage_new" },
  { path: "/coverage/:id/show", component: CoverageShow, name: "coverage_show" },
  {path: "/coverage/:id/edit", component: CoverageEdit, name: "coverage_edit"},
];

export default coverage;
